export default "__VITE_ASSET__DbvpAC_G__"